import { forwardRef } from "react";
import { Stack } from "@mui/system";
import styles from "./styles";
import two_stars_align_right from "assets/two_stars_align_right.webp";
import howItWorksImg from "assets/how_it_works.webp";

type IHowItWorksSectionProps = {
  isSM: boolean;
  smPad: string;
  widePad: string;
};

const HowItWorksSection = forwardRef(
  ({ isSM, smPad, widePad }: IHowItWorksSectionProps, ref) => {
    const classes = styles();
    return (
      <Stack
        direction="column"
        alignItems="center"
        sx={{
          position: "relative",
          padding: isSM ? smPad : `0px ${widePad}`
        }}
      >
        <img
          src={two_stars_align_right}
          alt={"Two stars"}
          style={{
            position: "absolute",
            right: 0
          }}
          loading="lazy"
        />

        <Stack
          sx={{
            marginBottom: "32px",
            width: "100%",
            justifyContent: "space-between"
          }}
        >
          <h2
            ref={ref as any}
            style={{
              textAlign: "center"
            }}
            className={classes.featureTitle}
          >
            How it works
          </h2>
          <p
            style={{ marginTop: 20 }}
            className={classes.featuresSectionDescription}
          >
            1. Just <strong>add</strong> HoyaApp to your Slack workspace, and{" "}
            <strong>choose</strong> a name for your kudos channel
          </p>
          <p
            style={{ marginTop: 20 }}
            className={classes.featuresSectionDescription}
          >
            2. Then we will <strong>create</strong> the channel for you, and{" "}
            <strong>invite</strong> the team to start celebrating the good vibes
          </p>
        </Stack>

        <Stack
          direction={isSM ? "column" : "row"}
          sx={{
            width: "100%",
            alignItems: "center",
            marginTop: isSM ? "0px" : "10px"
          }}
        >
          <img
            loading="lazy"
            src={howItWorksImg}
            alt=""
            style={{
              position: "relative",
              maxWidth: "100%",
              borderRadius: "16px",
              boxShadow: "0px 2px 14px rgba(0, 0, 0, 0.09)",
              filter: "drop-shadow(-18px 10px 5px #F2F1FF)",
              marginBottom: 30
            }}
          />
        </Stack>
      </Stack>
    );
  }
);

export default HowItWorksSection;
